module.exports = __webpack_public_path__ + "img/ring_y_0_null_1.a5d85684.png";